import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { NavLink, Outlet } from "react-router-dom";
import { getMySubscriptionsRequest } from "../../../store/user/user.actions";

const MySubscription = () => {
    const dispatch = useDispatch();
    const scrollRef = useRef(null);

    const scrollH = (e) => {
        e = window.event || e;
        let delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));
        scrollRef.current.scrollLeft -= delta * 40;
    };

    useEffect(() => {
        dispatch(getMySubscriptionsRequest());
    }, []);

    return (
        <div className="p-2 sm:p-4 lg:px-8 h-full overflow-hidden flex flex-col">
            <div className="">
                <div className="mb-3">
                    <h2 className="text-xl font-bold text-ebony-color capitalize">
                        My Subscription
                    </h2>
                    <p className="text-sm font-medium text-black-60">
                        View account that you subscribe
                    </p>
                </div>

                {/* <div className="p-4 pb-0 bg-white rounded-lg rounded-br-none rounded-bl-none border border-b-0 border-black-10">
                    <ul
                        onWheel={(e) => scrollH(e)}
                        ref={scrollRef}
                        className="flex items-center pb-[6px] border-b border-black-10 overflow-x-auto no-scrollbar"
                    >
                        <li>
                            <NavLink
                                to="/page/subscription/private-lounge"
                                className="text-sm font-medium text-black-60 hover:text-orange-color pb-[7px] px-6 hover:border-b-2 border-orange-color capitalize marketplace-nav whitespace-nowrap"
                            >
                                Private lounge
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/page/subscription/vip-circle"
                                className="text-sm font-medium text-black-60 hover:text-orange-color pb-[7px] px-6 hover:border-b-2 border-orange-color capitalize marketplace-nav whitespace-nowrap"
                            >
                                VIP circle
                            </NavLink>
                        </li>
                    </ul>
                </div> */}
            </div>

            <div className="flex-grow overflow-y-auto p-4 bg-white rounded-lg rounded-tr-none rounded-tl-none border border-t-0 border-black-10">
                <Outlet />
            </div>
        </div>
    );
};

export default MySubscription;
